define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/def/ViewRef",
	"csi/util",
	"csi/xml"
], function(lang,def,Action,ActionFactory,ViewRef,util,xml) {

	return ActionFactory.declare("Link", Action, {
		// String: aggregate relationship to store original item
		aggregateId: null,

		// String: composite relationship to store copied item
		compositeId: null,

		// String: form to show when unlink node (set to "" to disable form) (optional)
		idForm: null,

		constructor: function(obj) {
			// summary: read required members
			this.idAttr = util.getProperty(obj, "ActualId", "Actual");
			this.aggregateId = util.getProperty(obj, "AggregateId", "Original");
			this.compositeId = util.getProperty(obj, "CompositeId", "Copy");

			// set defaults for action if not explicitly configured
			this.m_tag = this.m_tag || "Link";
			this.m_id = this.m_id || (this.m_tag + this.idAttr);
			this.m_viewRef = this.m_viewRef || lang.mixin(new ViewRef(), {m_id: def.DEFAULT_FORM_ID});

			if (!this.m_typeControl && !this.m_class) {
				this.m_class = "iconLink";
				this.m_typeControl = def.ACTION_ICON;
			}
			this.idForm = util.getProperty(obj, "Form", def.DEFAULT_FORM_ID);
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		isValid: function()	{
			// summary: check for required members
			return this.idAttr && this.compositeId && this.inherited(arguments);
		},

		_getNameParams: function(/*csi.LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			return [];
		},

		checkNodeAccess: function(/*Node*/node, /*Context*/ctx) {
			// summary: make sure user has access to edit actual relationship and that there is either
			// already an aggregate item or there is a view to pick it
			return this.inherited(arguments) && xml.isValidURL(this._getAggregateUrl(node, ctx));
		},

		isToggledInitially: function(/*Context*/ctx) {
			// summary: determine if action should be in toggled state initially
			var	node = ctx.getNode();

			return xml.isValidURL(this._getAggregateUrl(node, ctx)) &&
				   xml.isValidURL(xml.nodeGetAttributeValue(node, this.compositeId));
		},

		_getAggregateUrl: function(/*Node*/node, /*Context*/ctx) {
			// summary: return url for aggregate relationship
			return node ? node[this.aggregateId] : null;
		}
	});
});